import CurrencyInput from 'components/base/currency-input';
import { RequestItemType } from 'models/item-request.model';
import React from 'react';

interface MainstoreRequestItemReturnProps {
  item: RequestItemType;
  onItemChange?: (updatedItem: RequestItemType) => void;
}

const MainstoreRequestItemReturn = ({ item, onItemChange }: MainstoreRequestItemReturnProps) => {
  const updateQuantityReturned = (value: string) => {
    if (Number(value) <= Number(item.quantity)) {
      const updatedItem: RequestItemType = {
        ...item,
        quantity_returned: Number(value)
      };
      onItemChange?.(updatedItem);
    }
  };
  return (
    <div>
      <CurrencyInput
        label='Quantity returned'
        placeholder='Quantity returned'
        name='quantity_returned'
        hasUnit
        unitValue={item.ingredient.unit_type}
        disableUnit
        hideCurrency
        explicitRender
        value={item.quantity_returned}
        onWheel={(e) => e.currentTarget.blur()}
        onChange={updateQuantityReturned}
      />
    </div>
  );
};

export default MainstoreRequestItemReturn;
